"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var const_1 = require("./const");
var elements_1 = require("./elements");
var types_1 = require("./types");
var utils_1 = require("./utils");
var styles = {
    height: '100%',
    width: '100%',
};
var PI = Math.PI;
exports.Pie3D = function (_a) {
    var config = _a.config, data = _a.data;
    var _b = react_1.useState(0), height = _b[0], setHeight = _b[1];
    var _c = react_1.useState(0), width = _c[0], setWidth = _c[1];
    var _d = react_1.useState(0), rx = _d[0], setRx = _d[1];
    var _e = react_1.useState(typeof data[0] === 'number' ? utils_1.mapRawData(data) : utils_1.mapData(data)), mappedData = _e[0], setMappedData = _e[1];
    var pieConfig = __assign(__assign({}, const_1.DEFAULT_CONFIG), config);
    var ref = react_1.useRef(null);
    react_1.useEffect(function () {
        if (ref.current) {
            setHeight(ref.current.clientHeight);
            setWidth(ref.current.clientWidth);
            setRx(height / 2 * pieConfig.size);
        }
    });
    var moveElement = function (startAngle) { return setMappedData(mappedData.map(function (element) {
        return element.startAngle === startAngle ? __assign(__assign({}, element), { moved: !element.moved }) : element;
    })); };
    var ry = rx * pieConfig.angle / 90;
    var pathVariables = __assign({ moveElement: moveElement,
        rx: rx,
        ry: ry }, pieConfig);
    var mappedTopAndLabelElements = mappedData.map(function (item, index) {
        return react_1.default.createElement(elements_1.Path, { data: item, key: index, pathVariables: pathVariables, type: types_1.PathType.Top });
    });
    var mappedP1Elements = mappedData.map(function (item, index) { return rx && item.endAngle < PI / 2 && (react_1.default.createElement("g", { key: index },
        react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Start }),
        react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.End }),
        react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Outer }))); });
    var mappedP2Elements = mappedData
        .sort(function (a, b) { return b.startAngle - a.startAngle; })
        .map(function (item, index) { return rx && item.endAngle >= PI / 2 && item.endAngle <= PI && (react_1.default.createElement("g", { key: index },
        react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.End }),
        react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Start }),
        react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Outer }))); });
    var mappedP3Elements = mappedData
        .sort(function (a, b) { return b.startAngle - a.startAngle; })
        .map(function (item, index) { return rx && item.endAngle > PI && item.endAngle <= 3 * PI / 2 && (react_1.default.createElement("g", { key: index },
        react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.End }),
        item.startAngle > PI && react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Start }),
        react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Inner }),
        item.startAngle <= PI && react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Start }),
        item.startAngle < PI && react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Outer }))); });
    var mappedP4Elements = mappedData
        .sort(function (a, b) { return a.startAngle - b.startAngle; })
        .map(function (item, index) {
        return rx && item.endAngle > 3 * PI / 2 && item.startAngle > PI / 2 && (react_1.default.createElement("g", { key: index },
            react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Start }),
            react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.End }),
            react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Inner }),
            item.startAngle < PI && react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Outer })));
    });
    var exception1 = mappedData.map(function (item, index) { return rx && item.endAngle > 3 * PI / 2 && item.startAngle <= PI / 2 && (react_1.default.createElement("g", { key: index },
        react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.End }))); });
    var exception2 = mappedData.map(function (item, index) { return rx && item.endAngle > 3 * PI / 2 && item.startAngle <= PI / 2 && (react_1.default.createElement("g", { key: index },
        react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Start }),
        react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Inner }),
        item.startAngle < PI && react_1.default.createElement(elements_1.Path, { data: item, pathVariables: pathVariables, type: types_1.PathType.Outer }))); });
    return (react_1.default.createElement("svg", { ref: ref, style: styles },
        react_1.default.createElement("g", { transform: "translate(" + width / 2 + ", " + height / 2 + ")" },
            exception1,
            mappedP4Elements,
            mappedP1Elements,
            mappedP3Elements,
            mappedP2Elements,
            exception2,
            mappedTopAndLabelElements)));
};
